import { BaseEntity } from '../../../../models';

export class LeadContato implements BaseEntity {
    readonly id: number;
    idLead: number;
    tipo: number;
    nome: string;
    fone: string;
    celular: string;
    email: string;
    anotacao: string;

    constructor(tipo: number = null) {
        this.tipo = tipo;
    }
}
